import App from "./app"
import ReactDOM from 'react-dom/client';
import './utils/i18n/i18next';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <App />
);
